import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Nivel } from '../models'
import { UsuarioSymbol } from '../../../components/layout/UsuarioSymbol'

type TProps = {
  handleDragEnd: (arg: any) => void
  eliminarResponsable: (id: string, nivelKey: any) => void
  agregarNivel: () => void
  eliminarNivel: (key: string) => void
  isModoEditar: boolean
  nivelGlobal: Nivel
}

/**
 * UI de drag & drop de responsables entre niveles (react-beautiful-dnd).
 * Invariantes:
 * - No se pueden dejar niveles intermedios sin responsables.
 * - Solo el ultimo nivel vacio puede eliminarse.
 * - El `draggableId` usa `idUsuario` (string), requerido por la libreria.
 */
export const NivelesCards = ({
  handleDragEnd,
  eliminarNivel,
  agregarNivel,
  isModoEditar,
  nivelGlobal,
  eliminarResponsable,
}: TProps) => {
  const ultimaPosicion = Object.keys(nivelGlobal).pop()
  return (
    <div className='d-flex flex-column mt-10 justify-content-center'>
      <DragDropContext onDragEnd={handleDragEnd}>
        {Object.entries(nivelGlobal).map(([key, data]) => (
          <div key={key} className='w-100'>
            <div className='d-flex flex-column mb-10 border-container'>
              <div className='d-flex justify-content-between align-items-center mx-4 mt-2'>
                <i className='d-flex justify-content-start fs-2'>{data.titulo}</i>
                {key === ultimaPosicion && data?.responsables?.length === 0 ? (
                  <OverlayTrigger overlay={<Tooltip>Eliminar nivel</Tooltip>}>
                    <button
                      className='btn btn-outline-danger btn-icon btn-circle btn-sm'
                      type='button'
                      title='Eliminar Nivel'
                      onClick={() => eliminarNivel(key)}>
                      <i className='fa-solid fa-minus fs-1'></i>
                    </button>
                  </OverlayTrigger>
                ) : (
                  <div className='mt-10'></div>
                )}
              </div>
              <Droppable droppableId={key} direction='horizontal'>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className='d-flex w-100 h-200px scroll-y'>
                    {data?.responsables?.map((el: any, index: number) => (
                      <Draggable key={el.idUsuario} index={index} draggableId={el.idUsuario || ''}>
                        {(provided) => (
                          <div>
                            <div
                              className='my-5 mx-5 w-350px'
                              ref={provided.innerRef}
                              {...provided.draggableProps}>
                              <div className='card border p-5 w-100'>
                                <div className=''>
                                  <div className='d-flex justify-content-between h-60px'>
                                    <div
                                      className='d-flex align-items-center justify-content-start'
                                      {...provided.dragHandleProps}>
                                      <UsuarioSymbol
                                        nombre={el.nombre}
                                        primerApellido={el.apellidoPaterno}
                                        perfil={el.perfil}
                                        estatus={el.estatus!}
                                        ausente={el.ausente}
                                      />
                                      <div className='fw-bolder fs-4 mt-1'>
                                        {el.nombre} {el.apellidoPaterno} {el.apellidoMaterno}
                                      </div>
                                    </div>
                                    <div className='d-flex'>
                                      <OverlayTrigger overlay={<Tooltip>Eliminar</Tooltip>}>
                                        <button
                                          type='button'
                                          title={`Eliminar Responsable ${el.nombre}`} 
                                          className='btn btn-sm btn-icon btn-white'
                                          onClick={() => {
                                            isModoEditar
                                              ? eliminarResponsable(el.idContacto, key)
                                              : eliminarResponsable(el.idUsuario, key)
                                          }}>
                                          <i className='bi bi-x-lg'></i>
                                        </button>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                  <div className='mt-3'>
                                    <div className='d-flex'>
                                      <i className='bi bi-envelope fs-3'></i>
                                      <p className='mx-2'>{el.correo}</p>
                                    </div>
                                    <div className='d-flex'>
                                      <i className='bi bi-telephone fs-3'></i>
                                      <p className='mx-2'>{el.telefono}</p>
                                    </div>
                                    <div className='d-flex'>
                                      <i className='bi bi-archive fs-3'></i>
                                      <p className='mx-2'>{el.descPosicion}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </div>
        ))}
      </DragDropContext>
      <div className='d-flex flex-column h-200px justify-content-center border-container-empty'>
        <i className='d-flex justify-content-center fs-2'>Agregar nivel</i>
        <div className='d-flex justify-content-center mt-2'>
          <OverlayTrigger placement='top' overlay={<Tooltip>Agregar nivel</Tooltip>}>
            <button
              className='btn btn-outline-success btn-icon btn-circle btn-sm '
              type='button'
              title='Agregar Nivel'
              onClick={() => agregarNivel()}>
              <i className='fa-solid fa-plus fs-1'></i>
            </button>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}
